import {partial} from 'lodash'
import moment from 'moment'
import React from 'react'
import {Redirect} from 'react-router-dom'
import {Consumer} from '../../context'
import views from '../../components/planning'
import './planning.styl'

const defaultDates = {
  month: () => ({
    start: moment().startOf('month').startOf('week').format('YYYY-MM-DD'),
    end: moment().endOf('month').endOf('week').format('YYYY-MM-DD')
  }),
  week: () => ({
    start: moment().startOf('week').format('YYYY-MM-DD'),
    end: moment().endOf('week').format('YYYY-MM-DD')
  }),
  day: () => ({
    start: moment().format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD')
  })
}

function getView ({view, section}) {
  if (section == 'templates')
    return views[section] 
  else
    return views[view] || views.week
}

export default function Planning() {
  return (<Consumer>{ (context) => {
    const View = getView(context)
    const view = context.view || 'week'
    const query = context.query.start ? context.query : (defaultDates[view] || defaultDates.week)()
    const date = getDate(query)
    if (['week','day','month'].indexOf(view) >= 0 && !context.query.start && (context.page == 'planning' || context.page == 'planning-rd')) {
      const link = context.link({view}, '/:languageId/:role/:page/:view', {preserveQuery: true, query})
      return (<Redirect to={link} />)
    } else {
      return (<View {...{date, view, query}} />)
    }

  }}</Consumer>)
}

function getTime(date) {
  return moment(date).toDate().getTime()
}

function getDate ({start, end}) {
  const time = (getTime(start) + getTime(end)) / 2
  return partial(moment, time)
}
